import React from 'react';

const LocalLayout = ({ children }) => {
  return <div className="flex">{children}</div>;
};

export default LocalLayout;
